import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// KYG002001Url
const menuURL = "/";
// KYG002001のパンくず
const kyg002001Breadcrumbs = [
  {
    name: "KYG000000.label.breadcrumb_international_delivery",
    message: "KYG000000.label.world_portal_top",
    link: menuURL
  }
];

// KYG011001
const issueMenu = "/issue-shipping";

// KYG011001のパンくず
const kyg011001Breadcrumbs = [
  ...kyg002001Breadcrumbs,
  {
    name: "KYG000000.label.shipping_label_menu",
    message: "KYG000000.label.shipping_label_menu",
    link: issueMenu
  }
];

// KYG073001
const searchIssueHistoryUrl = "/search-issue-history";
// 履歴から発行（送り状）
const searchShipmentHistory = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.issue_from_history_shipping_label",
    link: searchIssueHistoryUrl
  }
];
// 履歴から発行（インボイス）
const searchInvoiceHistory = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.issue_from_history_invoice",
    link: searchIssueHistoryUrl
  }
];
// 送り状から発行
const issueFromInvoice = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.issue_from_invoice",
    link: searchIssueHistoryUrl
  }
];

// KYG072001Url
const confirmationPrintUrl = "/confirmation-print";

const issueFromInvoiceSingle = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.issue_from_invoice",
    link: confirmationPrintUrl
  }
];

// KYG076001
const searchReIssueUrl = "/search-reissue";
// 再発行（送り状）
const reissueShipping = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.reissue_shipping_label",
    link: searchReIssueUrl
  }
];
// KYG090001
const importExDataUrl = "/import-ex-data";
// KYG090001のパンくず
const KYG090001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.import_external_data",
    link: importExDataUrl
  }
];

// KYG110001
const importExMasterUrl = "/import-ex-master";
// KYG110001のパンくず
const KYG110001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.import_external_master",
    link: importExMasterUrl
  }
];

// 再発行（インボイス）
const reissueInvoice = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.reissue_invoice",
    link: searchReIssueUrl
  }
];

// KYG060001
const regInvoiceUrl = "/reg-invoice";

// KYG060001のパンくず
const kyg060001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG060001.title",
    link: regInvoiceUrl
  }
];

// KYG070001
const searchIssueSavedUrl = "/search-issue-saved";
const kyg070001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.issue_from_save",
    link: searchIssueSavedUrl
  }
];

// KYG004001Url
const searchProhibitionProductUrl = "/search-prohibitions";
// KYG004001のパンくず
const kyg004001Breadcrumbs = [
  ...kyg002001Breadcrumbs,
  {
    name: "KYG000000.label.breadcrumb_search_prohibited_goods",
    link: searchProhibitionProductUrl
  }
];

// KYG003001Url
const checkTransportService = "/check-transport-service";
// KYG003001のパンくず
const kyg003001Breadcrumbs = [
  ...kyg002001Breadcrumbs,
  {
    name: "KYG000000.label.breadcrumb_search_delivery_services",
    link: checkTransportService
  }
];

// KYG013001
const regIssueEnd = "/reg-issue-end";
// KYG013001のパンくず
const kyg013001Breadcrumbs = [
  ...kyg002001Breadcrumbs,
  {
    name: "KYG000000.label.breadcrumb_search_delivery_services",
    link: regIssueEnd
  }
];

// KYG017001Url
const editSettingsUrl = "/edit-settings";
// KYG017001のパンくず
const kyg017001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.various_setting_update",
    link: editSettingsUrl
  }
];

// KYG010001Url
const usingSettingsUrl = "/using-settings";
// KYG010001のパンくず
const kyg010001Breadcrumbs = [
  ...kyg002001Breadcrumbs,
  {
    name: "KYG000000.label.when_using",
    link: usingSettingsUrl
  }
];

// KYG021001
const regSingleIssueUrl = "/reg-single-issue";
// KYG021001のパンくず
const kyg021001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.one_by_one_issue",
    link: regSingleIssueUrl
  }
];

// KYG014001
const printCompleteUrl = "/print-complete";

// KYG076001
const kyg076001Breadcrumbs = [reissueShipping, reissueInvoice];
// KYG050001Url
const printCheckUrl = "/print-check";

// KYG073001のパンくず
const kyg073001Breadcrumbs = [
  searchShipmentHistory,
  searchInvoiceHistory,
  issueFromInvoice
];

// KYG081001
const searchIssueUrl = "/search-issue";
// KYG081001のパンくず
const kyg081001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.search_issued_data",
    link: searchIssueUrl
  }
];

// KYG081001
const shipmentListPrintUrl = "/shipment-list-print";
// KYG081001のパンくず
const kyg083001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.list_shipping_schedule_printing",
    link: shipmentListPrintUrl
  }
];

// KYG075001
const editIssueHistoryUrl = "/edit-issue-history";

// KYG090002
const importIssueResultUrl = "/import-issue-result";
// KYG090002のパンくず
const KYG090002Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.import_external_data",
    link: importIssueResultUrl
  }
];

// KYG110002
const importMasterResultUrl = "/import-master-result";
// KYG110002のパンくず
const KYG110002Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.import_external_master",
    link: importMasterResultUrl
  }
];
// KYG100001
const regEditMasterUrl = "/reg-edit-master";
// KYG100001のパンくず
const KYG100001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.master_registers_edits",
    link: regEditMasterUrl
  }
];
// KYG120001
const connectWithExternalSystemUrl = "/connect-with-external-system";
// KYG120001のパンくず
const KYG120001Breadcrumbs = [
  ...kyg011001Breadcrumbs,
  {
    name: "KYG000000.label.connect_with_external_system",
    link: connectWithExternalSystemUrl
  }
];

const routes = [
  {
    path: menuURL,
    name: "Menu",
    component: () => import("@/modules/menu/pages/Menu"),
    meta: {
      breadcrumb: kyg002001Breadcrumbs,
      title: "KYG002001.title"
    }
  },
  {
    path: searchProhibitionProductUrl,
    name: "SearchProhibition",
    component: () => import("@/modules/prohibition/pages/SearchProhibition"),
    meta: {
      breadcrumb: kyg004001Breadcrumbs,
      title: "KYG004001.title"
    }
  },
  {
    path: printCompleteUrl,
    name: "PrintComplete",
    component: () => import("@/modules/printComplete/pages/PrintComplete"),
    meta: {
      title: "KYG014001.title"
    }
  },
  {
    path: "/errorserver",
    name: "ErrorServer",
    component: () => import("@/modules/error/pages/ErrorServer"),
    meta: {
      title: "KYG000002.system_error_title",
      titleConnectionErr: "KYG000002.connection_error_title"
    }
  },
  {
    path: checkTransportService,
    name: "CheckTransportService",
    component: () =>
      import("@/modules/transportServices/pages/CheckTransportService"),
    meta: {
      breadcrumb: kyg003001Breadcrumbs,
      title: "KYG003001.title"
    }
  },
  {
    path: regIssueEnd,
    name: "RegIssueEnd",
    component: () => import("@/modules/regIssueEnd/pages/RegIssueEnd"),
    meta: {
      breadcrumb: kyg013001Breadcrumbs,
      title: "KYG013001.title"
    }
  },

  {
    path: issueMenu,
    name: "IssueMenu",
    component: () => import("@/modules/issueMenu/pages/IssueMenu"),
    meta: {
      breadcrumb: kyg011001Breadcrumbs,
      title: "KYG011001.title"
    }
  },
  {
    path: editSettingsUrl,
    name: "EditSettings",
    component: () => import("@/modules/editSettings/pages/EditSettings"),
    meta: {
      breadcrumb: kyg017001Breadcrumbs,
      title: "KYG017001.title"
    }
  },
  {
    path: usingSettingsUrl,
    name: "UsingSettings",
    component: () => import("@/modules/usingSettings/pages/UsingSettings"),
    meta: {
      breadcrumb: kyg010001Breadcrumbs,
      title: "KYG010001.title"
    }
  },
  {
    path: regSingleIssueUrl,
    name: "RegSingleIssue",
    component: () => import("@/modules/regSingleIssue/pages/RegSingleIssue"),
    meta: {
      breadcrumb: kyg021001Breadcrumbs,
      title: "KYG021001.title"
    }
  },
  {
    path: regInvoiceUrl,
    name: "RegInvoice",
    component: () => import("@/modules/regInvoice/pages/RegInvoice"),
    meta: {
      breadcrumb: kyg060001Breadcrumbs,
      title: "KYG060001.title"
    }
  },
  {
    path: confirmationPrintUrl,
    name: "ConfirmationPrint",
    component: () =>
      import("@/modules/confirmationPrint/pages/ConfirmationPrint"),
    meta: {
      breadcrumbParam: issueFromInvoiceSingle,
      title: "KYG072001.title"
    }
  },
  {
    path: printCheckUrl,
    name: "PrintCheck",
    component: () => import("@/modules/printCheck/pages/PrintCheck"),
    meta: {
      title: "KYG050001.title"
    }
  },
  {
    path: searchReIssueUrl,
    name: "SearchReIssue",
    component: () => import("@/modules/searchReIssue/pages/SearchReIssue"),
    meta: {
      breadcrumb: kyg076001Breadcrumbs,
      title: "KYG076001.title"
    }
  },
  {
    path: searchIssueHistoryUrl,
    name: "SearchIssueHistory",
    component: () =>
      import("@/modules/searchIssueHistory/pages/SearchIssueHistory"),
    meta: {
      breadcrumb: kyg073001Breadcrumbs,
      title: "KYG073001.title"
    }
  },
  {
    path: searchIssueUrl,
    name: "SearchIssue",
    component: () => import("@/modules/searchIssue/pages/SearchIssue"),
    meta: {
      breadcrumb: kyg081001Breadcrumbs,
      title: "KYG081001.title"
    }
  },
  {
    path: shipmentListPrintUrl,
    name: "ShipmentListPrint",
    component: () =>
      import("@/modules/shipmentListPrint/pages/ShipmentListPrint"),
    meta: {
      breadcrumb: kyg083001Breadcrumbs,
      title: "KYG083001.title"
    }
  },
  {
    path: searchIssueSavedUrl,
    name: "SearchIssueSaved",
    component: () =>
      import("@/modules/searchIssueSaved/pages/SearchIssueSaved"),
    meta: {
      breadcrumb: kyg070001Breadcrumbs,
      title: "KYG070001.title"
    }
  },
  {
    path: editIssueHistoryUrl,
    name: "EditIssueHistory",
    component: () =>
      import("@/modules/editIssueHistory/pages/EditIssueHistory"),
    meta: {
      title: "KYG075001.title"
    }
  },
  {
    path: importIssueResultUrl,
    name: "ImportIssueResult",
    component: () =>
      import("@/modules/importIssueResult/pages/ImportIssueResult"),
    meta: {
      breadcrumb: KYG090002Breadcrumbs,
      title: "KYG090002.title"
    }
  },
  {
    path: importExDataUrl,
    name: "ImportExData",
    component: () => import("@/modules/importExData/pages/ImportExData"),
    meta: {
      breadcrumb: KYG090001Breadcrumbs,
      title: "KYG090001.title"
    }
  },
  {
    path: importExMasterUrl,
    name: "ImportExMaster",
    component: () => import("@/modules/importExMaster/pages/ImportExMaster"),
    meta: {
      breadcrumb: KYG110001Breadcrumbs,
      title: "KYG110001.title"
    }
  },
  {
    path: importMasterResultUrl,
    name: "ImportMasterResult",
    component: () =>
      import("@/modules/importMasterResult/pages/ImportMasterResult"),
    meta: {
      breadcrumb: KYG110002Breadcrumbs,
      title: "KYG110002.title_header"
    }
  },
  {
    path: regEditMasterUrl,
    name: "RegEditMaster",
    component: () => import("@/modules/regEditMaster/pages/RegEditMaster"),
    meta: {
      breadcrumb: KYG100001Breadcrumbs,
      title: "KYG100001.title"
    }
  },
  {
    path: connectWithExternalSystemUrl,
    name: "ConnectWithExternalSystem",
    component: () => import("@/modules/connectWithExternalSystem/pages/ConnectWithExternalSystem"),
    meta: {
      breadcrumb: KYG120001Breadcrumbs,
      title: "KYG120001.title"
    }
  },
  {
    path: "*",
    redirect: { name: "ErrorServer" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  sessionStorage.setItem("previousPathName", !from ? "" : from.name);
  sessionStorage.setItem("nextPathName", !to ? "" : to.name);
  if (to.name !== "ErrorServer") {
    // Remove duplicated-login flag after user change url to other page
    sessionStorage.removeItem("duplicated-login");
  }
  next();
});

export default router;